var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isPage('detail'))?_c('Header'):_vm._e(),_vm._v(" "),((_vm.isPage('todo') || _vm.isPage('doing') || _vm.isPage('done') || _vm.isPage('flow_cc')|| _vm.isPage('apply')))?_c('Nav'):_vm._e(),_vm._v(" "),_c('div',[(_vm.RouterShow)?_c('router-view'):_vm._e()],1),_vm._v(" "),_c('a-back-top')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e19417dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/todoCenter/default/wechat/layout/index.vue
// module id = PxNp
// module chunks = 16